import ajax from "@/lib/ajax";

// 查询患者列表
export async function QueryPdPatientList(payload: any) {
    let res = await ajax.post(`/api/services/app/PDPatientManage/QueryPdPatientList`, payload);
    return res.data.result;
}


// WEBPACK FOOTER //
// ./src/api/pdIntegratedManage/pdPatientManage/index.ts